var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stb-main',[_c('stb-profile',{attrs:{"module":"employers"}}),_vm._v(" "),_c('stb-notifications',{attrs:{"slot":"sidebar","title":_vm.$t('notifications'),"items":_vm.notifications,"showTimeline":true,"showTitle":_vm.me},on:{"item-click":_vm.click_item},slot:"sidebar"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c19098a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employer.vue
// module id = null
// module chunks = 